/**
 * Admin DB-env switch (US-AIF.P0-0247 · @UC9419) — một nguồn sự thật api ↔ admin web cho cơ chế
 * "xem data SANDBOX từ admin". Header + hằng lỗi dùng chung, tránh drift magic-string.
 *
 * BẤT BIẾN CỨNG (index §6 — @gate security):
 * - env=`real` là MẶC ĐỊNH fail-safe: thiếu/để-trống/giá-trị-lạ ở header ⇒ đọc DB CHÍNH.
 * - env=`sandbox` chỉ khi: header đúng `sandbox` VÀ role ∈ {SUPER_ADMIN, OPS}. Role khác ⇒ bỏ header.
 * - sandbox = READ-ONLY qua admin: mọi WRITE khi env=sandbox ⇒ 409 `ADMIN_SANDBOX_READONLY`.
 * - KHÔNG tin body — chỉ đọc header. KHÔNG fallback im lặng sang real khi sandbox chưa cấu hình (503).
 */

/** 2 môi trường dữ liệu admin. `real` = DATABASE_URL (mặc định); `sandbox` = AI_PREVIEW_DATABASE_URL. */
export type AdminDbEnv = "real" | "sandbox";

/** Giá trị mặc định fail-safe. */
export const ADMIN_DB_ENV_DEFAULT: AdminDbEnv = "real";

/** Tên header (lowercase — HTTP header case-insensitive) admin web đính khi muốn xem sandbox. */
export const ADMIN_DB_ENV_HEADER = "x-admin-db-env" as const;

/** Giá trị header kích hoạt sandbox (phân biệt hoa/thường: chỉ đúng chuỗi này). */
export const ADMIN_DB_ENV_SANDBOX_VALUE = "sandbox" as const;

/**
 * Code 409 khi admin cố GHI (mutation) trong lúc env=sandbox — sandbox là READ-ONLY qua admin.
 * Dùng chung api (S02 guard write) ↔ admin web (S03 hiển thị lỗi rõ), tránh admin ghi nhầm env phụ.
 */
export const ADMIN_SANDBOX_READONLY_CODE = "ADMIN_SANDBOX_READONLY" as const;
export const ADMIN_SANDBOX_READONLY_MESSAGE =
  "Đang xem môi trường SANDBOX — chỉ đọc. Không thể chỉnh sửa dữ liệu qua môi trường phụ.";
